import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import GradeTagSelection from './GradeTagSelection';
import withModal from '../../../../../../../components/global/modal/withModal';
import GradeTagSelectionHeader from '../GradeTagSelectionHeader';

export const GRADE_TAG_SELECTION_MODAL = 'modals/GRADE_TAG_SELECTION_MODAL';

const propTypes = {
  identity: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  albumFolder: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
  onRequestClose: PropTypes.func.isRequired,
  actionProps: PropTypes.shape({
    onComplete: PropTypes.func,
  }),
};

const GradeTagSelectionModal = ({
  identity,
  albumFolder,
  onRequestClose,
  actionProps,
}) => {
  const { onComplete } = actionProps ?? {};

  return (
    <Fragment>
      <GradeTagSelectionHeader identity={identity} className="mb-2" />

      <GradeTagSelection
        identity={identity}
        albumFolder={albumFolder}
        onComplete={() => {
          onRequestClose();
          onComplete?.();
        }}
      />
    </Fragment>
  );
};

GradeTagSelectionModal.propTypes = propTypes;

export default withModal(GradeTagSelectionModal, {
  name: GRADE_TAG_SELECTION_MODAL,
  hideHeader: true,
  size: 'sm',
  type: 'full',
});
